export const providerNames = { openai: "OpenAI", anthropic: "Anthropic", deepseek: "DeepSeek", kimi: "Kimi", typesafe: "TypeSafe AI" };
const providerOrder = Object.keys(providerNames);
const compareText = (a = "", b = "") => a < b ? -1 : a > b ? 1 : 0;

// Use exact model IDs, as in the provider table. Neither opaque choice refs nor
// translated display names should move a model after saving or refreshing.
export function compareProviderModels(a, b) {
  const rank = provider => { const index = providerOrder.indexOf(provider); return index < 0 ? providerOrder.length : index; };
  return rank(a.provider) - rank(b.provider) || compareText(a.provider, b.provider) || compareText(a.model ?? a.id, b.model ?? b.id) || compareText(a.choiceRef, b.choiceRef);
}

export function modelChoices(choices = [], currentRef = "") {
  const unique = new Map();
  for (const choice of [...choices].sort(compareProviderModels)) {
    const key = choice.provider && choice.model ? `${choice.provider}/${choice.model}` : choice.choiceRef;
    const previous = unique.get(key);
    if (!previous || choice.choiceRef === currentRef || previous.choiceRef !== currentRef && choice.choiceRef.startsWith("configured-") && !previous.choiceRef.startsWith("configured-")) unique.set(key, choice);
  }
  return [...unique.values()].sort(compareProviderModels);
}

export const providerModelRows = (items, search = "") => items.flatMap(item => item.models.map(model => ({ ...model, provider: item.provider, availability: model.availability || { code: model.discovered === false ? "unconfirmed" : "available", message: model.discovered === false ? "Доступность ID не подтверждена списком провайдера." : "" } }))).filter(model => `${model.provider} ${model.id} ${model.name}`.toLowerCase().includes(search.trim().toLowerCase())).sort(compareProviderModels);

export const workspaceModelEnabled = (policy = {}, provider, model) => policy[`${provider}/${model}`] ?? (provider !== "typesafe");

// Approval is independent of provider availability and pricing.
export const approvedProviderModelRows = (items, search = "") => providerModelRows(items, search).filter(model => model.workspaceEnabled !== false);

export const providerModelGroups = rows => {
  const ready = model => model.availability?.code === "available" && model.checkablePrice === true;
  return { available: rows.filter(ready), unconfirmed: rows.filter(model => !ready(model)) };
};
